import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { AbstractProgress } from 'foundations-components/transitional/components/AbstractProgress';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { TEST_IDS, URLS } from '../../../utils/constants';
import { handleError } from '../../../utils/errorHandling';
import { useCancellationMutation } from './useCancellationMutation';
import { useCancellationQuery } from './useCancellationQuery';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function CancellationModal({
  objectId,
  actions
}) {
  var _submitData$response$, _submitData$response;
  const {
    close
  } = actions;
  const {
    data: queryData,
    loading: queryLoading
  } = useCancellationQuery(objectId);
  const {
    sendEmailForSubscriptionCanceled
  } = useNotificationsQuery();
  const [onSubmit, {
    data: submitData,
    loading: submitLoading,
    error: submitError
  }] = useCancellationMutation(objectId, () => {
    close();
    actions.revalidate().catch(handleError);
  });
  if (queryLoading || !queryData) {
    return /*#__PURE__*/_jsxs(Modal, {
      use: "danger",
      "data-test-id": TEST_IDS.Cancel,
      size: "auto",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.SubscriptionCancellationModal.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        style: {
          position: 'relative'
        },
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AbstractProgress, {
            Component: NanoProgress,
            maximum: 35
          }), /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "small",
            "data-test-id": "cancellation-modal:loading",
            minHeight: 100,
            layout: "centered",
            grow: true,
            showLabel: true,
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.SubscriptionCancellationModal.loadingMessage"
            })
          })]
        })
      })]
    });
  }
  const hasUserError = ((_submitData$response$ = submitData === null || submitData === void 0 || (_submitData$response = submitData.response) === null || _submitData$response === void 0 || (_submitData$response = _submitData$response.userErrors) === null || _submitData$response === void 0 ? void 0 : _submitData$response.length) !== null && _submitData$response$ !== void 0 ? _submitData$response$ : 0) > 0;
  const getBodyMessage = () => {
    if (sendEmailForSubscriptionCanceled) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "subscriptions.SubscriptionCancellationModal.body_jsx",
        options: {
          href: URLS.KBCancelSubscription,
          email: queryData.emailToDisplay
        },
        elements: {
          Link
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "subscriptions.SubscriptionCancellationModal.bodyNoNotify"
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    "data-test-id": TEST_IDS.Cancel,
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: close
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.SubscriptionCancellationModal.description"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: getBodyMessage()
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        disabled: !!submitError,
        loading: submitLoading,
        onClick: () => {
          onSubmit().catch(e => handleError(e));
        },
        failed: !!submitError || hasUserError,
        use: "danger",
        "data-test-id": `${TEST_IDS.Cancel}:submit`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.confirmCancel"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: close,
        "data-test-id": `${TEST_IDS.Cancel}:cancel`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "common.cancel"
        })
      })]
    })]
  });
}